import store from '@/store/store';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

export default async function getSecteursIdByUser(type, sansArchives = false) {
  await store.dispatch('parametres/loadParametresInterne', [PARAMETRES_INTERNE_KEYS.moduleSecteur.key]);
  const parametresInterne = store.getters['parametres/parametresInterne'];
  if (!parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key)) return [];
  await store.dispatch('parametres/loadParametres', [PARAMETRES_KEYS.secteur]);
  const parametre = store.getters['parametres/parametre'];
  const user = store.getters['user/user'];
  return parametre(PARAMETRES_KEYS.secteur)
    .filter(el => user.secteursId && user.secteursId.includes(el.id))
    .filter(el => !type || el.type === type)
    .filter(el => (sansArchives ? el.actif === true : el));
}

export async function getSecteursByIds(ids, type) {
  if (!ids?.length) return [];
  await store.dispatch('parametres/loadParametresInterne', [PARAMETRES_INTERNE_KEYS.moduleSecteur.key]);
  const parametresInterne = store.getters['parametres/parametresInterne'];
  if (!parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key)) return [];
  await store.dispatch('parametres/loadParametres', [PARAMETRES_KEYS.secteur]);
  const parametre = store.getters['parametres/parametre'];
  return parametre(PARAMETRES_KEYS.secteur)
    .filter(el => ids.includes(el.id))
    .filter(el => !type || el.type === type);
}
